import { Model } from "pinia-orm";
import Marker from "./Marker";

export default class Component extends Model {
  static entity = "components";
  static primaryKey = "uuid";
  static aosType = "COMPONENT";

  static typeKey = "componentContentTypeId";

  static types() {
    return {
      COMPONENT_FUSION: ComponentFusion,
    };
  }

  static fields() {
    return {
      uuid: this.uid(""),
      label: this.attr(null),
      type: this.attr(null),
      usage: this.attr([]),
      content: this.attr([]),
      masonryPit: this.attr(null),
      position: this.attr(null),
      locationInerted: this.attr(null),
      inertageDate: this.attr(null),
      remplacementDate: this.attr(null),
      inertageMethod: this.attr([]),
      isRetention: this.boolean(false),
      waterproofSurface: this.attr(null),
      temporality: this.attr(null),
      toolType: this.attr([]),
      impactedEnvironment: this.attr([]),
      fuelEnergy: this.attr([]),
      dielectricPresence: this.attr(null),
      dielectric: this.attr([]),
      storageType: this.attr([]),
      description: this.attr(null),
      backfillType: this.attr(null),
      nature: this.attr(null),
      areaPositioning: this.attr(null),
      burnedProducts: this.attr(null),
      surface: this.attr(null),
      isWaterproof: this.boolean(false),
      usedFluids: this.attr([]),
      state: this.attr(null),
      packaging: this.attr([]),
      usedSolvant: this.attr(null),
      productTypes: this.attr([]),
      structureDepth: this.attr(null),
      height: this.attr(null),
      wastesType: this.attr([]),
      sphcConnected: this.attr(null),
      underTension: this.attr(null),
      waterDepth: this.attr(null),
      integratedTank: this.attr(null),
      isKnownDepth: this.boolean(false),
      isCompartment: this.boolean(false),
      depth: this.attr(null),
      volume: this.attr(null),
      width: this.attr(null),
      length: this.attr(null),
      rejection: this.attr([]),
      historicalResearch: this.attr(null),
      isRemoteUnloading: this.boolean(false),
      rejectionLocation: this.attr(null),
      materials: this.attr([]),
      doubleSkin: this.attr(null),
      installationDate: this.attr(null),
      isPollutionTraces: this.boolean(false),
      remarks: this.attr(null),
      pictureUuid: this.attr(null),
      tagsType: this.attr([]),
      typology: this.attr("COMPONENT"),
      details: this.attr(null),
      tracerCompound: this.attr([]),
      analyticalStandard: this.attr(null),
      quantificationLimit: this.attr(null),
      isSourceTakenIntoAccount: this.boolean(true),
      justification: this.attr(null),
      diameter: this.attr(null),
      removalDate: this.attr(null),
      collectedEffluent: this.attr(null),
      presenceOfSludge: this.attr(null),
      locationInsideBuilding: this.attr(null),
      locationInsideZone: this.attr(null),
      locationPrecision: this.attr(null),
      buildingFk: this.attr(null),
      outdoorSpaceFk: this.attr(null),
      zoneFk: this.attr(null),
      reference: this.attr(null),
      storageConditions: this.attr(null),
      usageConditions: this.attr(null),
      wasteDisposalRecoveryConditions: this.attr(null),
      marker: this.morphOne(Marker, "markable_id", "markable_type"),
      existenceOfAConstraint: this.boolean(false),
      constraintAccuracy: this.attr(null),
      componentOrigin: this.string(""),
      incertitudeDescription: this.attr(null),
      incertitudeCategory: this.attr(null),
    };
  }
}

export class ComponentFusion extends Component {
  static entity = "componentFusions";
  static primaryKey = "uuid";
  static baseEntity = "components";

  static fields() {
    return {
      ...super.fields(),
      components: this.attr([]),
      componentContentTypeId: this.string("COMPONENT_FUSION"),
    };
  }
}
